import { render, staticRenderFns } from "./Gabarito.vue?vue&type=template&id=5ceb176d"
import script from "./Gabarito.vue?vue&type=script&lang=js"
export * from "./Gabarito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports